<!-- eslint-disable max-lines -->
<template>
  <div class="customer-product-list-page">
    <div class="query-conditions">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item>
          <el-input
            v-model.trim="keyword"
            clearable
            placeholder="请输入ADV编号,支持查询多个，以,号连接"
            style="width: 500px"
            @keyup.enter.native="handleFilter"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :loading="table.loading"
            @click="handleFilter"
          >
            查询
          </el-button>
          <el-button
            type="primary"
            @click="goLog"
          >
            产品日志
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div
      v-loading="table.loading"
      class="query-data"
    >
      <el-table
        ref="productTable"
        :row-key="row => row.product_id"
        :data="table.list"
        style="width: 100%"
        :row-class-name="getRowClass"
        @expand-change="handleExpandChange"
      >
        <el-table-column type="expand">
          <template slot-scope="scope">
            <template v-if="scope.row.account_num !== 0 || ((scope.row.accounts || []).length > 0) ">
              <div style="margin-bottom: 10px;">
                <el-button
                  v-if="scope.row.product_id !== 0"
                  type="primary"
                  size="small"
                  :disabled="!scope.row.rowSelection || !scope.row.rowSelection.length"
                  @click="batchBindSales(scope.row, 1)"
                >
                  批量绑定销售关系
                </el-button>
                <el-button
                  v-if="scope.row.product_id !== 0"
                  type="primary"
                  size="small"
                  :disabled="!scope.row.rowSelection || !scope.row.rowSelection.length"
                  @click="batchBindSales(scope.row, 2)"
                >
                  批量解绑销售关系
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  :disabled="!scope.row.rowSelection || !scope.row.rowSelection.length"
                  @click="advBatchBindProduct(scope.row)"
                >
                  批量修改产品
                </el-button>
              </div>
              <el-table
                :data="scope.row.accounts ? scope.row.accounts : scope.row.account"
                border
                @selection-change="(val) => handleTableSelectionChange(scope.row, val)"
              >
                <el-table-column
                  type="selection"
                  width="40"
                />
                <el-table-column
                  prop="adv_user_id"
                  label="ADV编号"
                >
                  <template slot-scope="scope1">
                    <span class="expand-adv-user-id">
                      {{ scope1.row.adv_user_id }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="agent_name"
                  label="代理商公司名称"
                >
                  <template slot-scope="scope1">
                    <div>
                      {{ scope1.row.agent_name || '--' }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="type"
                  label="是否归属销售"
                >
                  <template slot-scope="scope1">
                    <div>
                      {{ scope1.row.type === '1' ? '是' : '否' }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="remarks"
                  label="备注"
                >
                  <template slot-scope="scope1">
                    <div>{{ scope1.row.remarks || '--' }}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="360"
                >
                  <template slot-scope="scope1">
                    <div v-if="!scope.row._free">
                      <el-button
                        v-if="scope1.row.type === '1'"
                        type="text"
                        @click="advExBindSales(scope1.row, scope.row, 2)"
                      >
                        解除销售关系
                      </el-button>
                      <el-button
                        v-else
                        type="text"
                        @click="advExBindSales(scope1.row, scope.row, 1)" 
                      >
                        绑定客户销售
                      </el-button>
                      <el-button
                        type="text"
                        @click="advBindProduct(scope1.row, scope.row)"
                      >
                        修改产品关系
                      </el-button>
                    </div>
                    <!-- 暂无产品的操作 -->
                    <div v-else>
                      <el-button
                        type="text"
                        @click="advBindProduct(scope1.row, scope.row)"
                      >
                        关联产品
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                v-if="scope.row.pagination"
                small
                :current-page.sync="scope.row.pagination.page"
                :page-sizes="[10, 20, 50, 100]"
                layout="total, sizes, prev, pager, next"
                :total="Number(scope.row.account_num) || 0"
                style="margin-top: 30px; float: right"
                @size-change="(val) => handleAccountPageSizeChange(scope.row.product_id, val)"
                @current-change="(val) => handleAccountQueryPage(scope.row.product_id, val)"
              />
            </template>
          </template>
        </el-table-column>
        <el-table-column
          prop="product_name"
          label="合作产品"
        >
          <template slot-scope="scope">
            {{ scope.row._free ? '暂无产品' : scope.row.product_name || '--' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="_ownerName"
          label="销售"
        />
        <el-table-column
          prop="opt_name"
          label="运营"
        />
        <el-table-column
          label="操作"
          width="300"
        >
          <template slot-scope="scope">
            <el-button
              v-if="!scope.row._free"
              type="text"
              @click="modifySaler(scope.row)"
            >
              修改销售
            </el-button>
            <el-button
              v-if="!scope.row._free"
              type="text"
              @click="modifyBusiness(scope.row)"
            >
              修改运营
            </el-button>
            <el-button
              v-if="!scope.row._free"
              type="text"
              @click="bindAdv(scope.row)"
            >
              关联ADV账户
            </el-button>
            <el-button
              v-if="scope.row._free && noProductHasAdvs"
              type="text"
              @click="modifyMaster(scope.row)"
            >
              修改主体
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="query.page"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next"
        :total="table.total"
        style="margin-top: 30px; float: right"
        @size-change="handlePageSizeChange"
        @current-change="handleQueryPage"
      />
    </div>

    <!-- edit prod salor dialog -->
    <form-dialog
      :visible.sync="editProdSalorDlg.visible"
      title="修改销售"
      :loading="editProdSalorDlg.loading"
      width="600px"
      @submit="submitEditProdSalor"
    >
      <el-form
        ref="prodSalorForm"
        label-width="90px"
        :model="editProdSalorDlg.form"
      >
        <el-form-item
          label="客保销售"
          prop="owner"
        >
          <el-select
            v-model="editProdSalorDlg.form.owner"
            filterable
            clearable
            remote
            :remote-method="_searchSalors"
            placeholder="请输入并选择销售"
            :loading="editProdSalorDlg.searchLoading"
            style="width: 100%"
          >
            <el-option
              v-for="item in editProdSalorDlg.options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <p style="padding: 0 16px 0 16px;font-size: 12px;color: #888;">
          备注：所有adv广告主账户的归属都会修改，目前有{{ editProdSalorDlg.accountNum }}个adv广告主账户。
        </p>
      </el-form>
    </form-dialog>

    <!-- edit prod business dialog -->
    <form-dialog
      :visible.sync="editBusinessDlg.visible"
      title="修改运营"
      :loading="editBusinessDlg.loading"
      width="600px"
      @submit="submitEditBusiness"
    >
      <el-form
        ref="businessForm"
        label-width="90px"
        :model="editBusinessDlg.form"
      >
        <el-form-item
          label="客保运营"
          prop="owner"
        >
          <el-select
            v-model="editBusinessDlg.form.opt_id"
            filterable
            clearable
            remote
            :remote-method="_searchBuiness"
            placeholder="请输入并选择运营"
            :loading="editBusinessDlg.searchLoading"
            style="width: 100%"
          >
            <el-option
              v-for="item in editBusinessDlg.options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </form-dialog>

    <!-- bind adv dialog -->
    <form-dialog
      :visible.sync="bindAdvDlg.visible"
      title="绑定ADV账户"
      :loading="bindAdvDlg.loading"
      width="500px"
      @submit="submitBindAdvDlgForm"
    >
      <el-form
        ref="bindAdvForm"
        :model="bindAdvDlg.form"
        label-width="80px"
      >
        <el-form-item
          label="ADV账号"
          prop="adv_user_id"
          :rules="[{ required: true, message: 'ADV账号不能为空' }]"
        >
          <el-select
            v-model="bindAdvDlg.form.adv_user_id"
            clearable
            filterable
            remote
            reserve-keyword
            placeholder="请输入并选择ADV账号"
            :remote-method="_searchAdv"
            :loading="bindAdvDlg.searchLoading"
            style="width: 100%"
          >
            <el-option
              v-for="item in bindAdvDlg.saleOps"
              :key="item.id"
              :label="item.id + ' ' + item.company"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-show="saleUserName"
          label="账户名"
        >
          <el-input
            v-model="saleUserName"
            :disabled="true"
          />
        </el-form-item>
        <el-form-item
          v-show="saleAgentName"
          label="代理商"
        >
          <el-input
            v-model="saleAgentName"
            :disabled="true"
          />
        </el-form-item>
      </el-form>
    </form-dialog>

    <!-- edit master dialog -->
    <form-dialog
      :visible.sync="editMasterDlg.visible"
      title="修改主体"
      :loading="editMasterDlg.loading"
      width="600px"
      @submit="_processEditMaster"
    >
      <el-form label-width="80px">
        <el-form-item label="新主体">
          <el-select
            v-model="editMasterDlg.form.new_customer_id"
            filterable
            clearable
            remote
            :remote-method="_searchCustomer"
            placeholder="请选择新主体"
            :loading="editMasterDlg.searchLoading"
            style="width: 100%"
          >
            <el-option
              v-for="item in editMasterDlg.options"
              :key="item.id"
              :label="item.company"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </form-dialog>

    <!-- edit bind prod dialog -->
    <form-dialog
      :visible.sync="bindProdDlg.visible"
      title="关联合作产品"
      :loading="bindProdDlg.loading"
      width="600px"
      @submit="submitBindProdDlgForm"
    >
      <el-form
        ref="bindProdForm"
        label-width="80px"
        :model="bindProdDlg.form"
      >
        <el-form-item
          label="合作产品"
          prop="new_product_id"
        >
          <el-select
            v-model="bindProdDlg.form.new_product_id"
            filterable
            clearable
            placeholder="请选择合作产品"
            style="width: 100%"
            remote
            :remote-method="_fetchProduct"
          >
            <el-option
              v-for="item in productsOps"
              :key="item.product_id"
              :label="item.product_name"
              :value="item.product_id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </form-dialog>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import FormDialog from '@/components/FormDialog';

const req = new Request();

export default {
  name: 'ProductList',
  components: {
    FormDialog,
  },
  data() {
    return {
      // data
      customer_id: '',
      keyword: '',
      table: {
        list: [],
        total: 0,
        loading: false,
      },
      accountTable: {
        list: [],
        total: 0,
        loading: false,
      },
      query: {
        page: 1,
        page_size: 10,
      },
      // dlg
      editProdSalorDlg: {
        visible: false,
        loading: false,
        searchLoading: false,
        options: [],
        accountNum: 0,
        form: {
          owner: '',
          customer_id: '',
          product_id: '',
        },
      },
      // business
      editBusinessDlg: {
        visible: false,
        loading: false,
        searchLoading: false,
        options: [],
        accountNum: 0,
        form: {
          opt_id: '',
          customer_id: '',
          product_id: '',
        },
      },
      bindAdvDlg: {
        visible: false,
        loading: false,
        searchLoading: false,
        saleOps: [],
        form: {
          product_id: '',
          adv_user_id: '',
          customer_id: '',
        },
      },
      editMasterDlg: {
        visible: false,
        loading: false,
        searchLoading: false,
        options: [],
        form: {
          adv_user_ids: '',
          old_customer_id: '',
          new_customer_id: '',
        },
      },
      product_id: 0,
      bindProdDlg: {
        visible: false,
        loading: false,
        form: {
          new_product_id: '',
          adv_user_id: '',
          customer_id: '',
        },
      },
      // 只是针对无产品时，adv选中的数组
      noProdSelection: [],
      productsOps: []
    };
  },

  computed: {
    saleUserName() {
      const { saleOps, form } = this.bindAdvDlg;
      return (
        (saleOps.find((i) => i.id === form.adv_user_id) || {}).username || ''
      );
    },
    saleAgentName() {
      const { saleOps, form } = this.bindAdvDlg;
      return (
        (saleOps.find((i) => i.id === form.adv_user_id) || {})
          .belong_username || ''
      );
    },
    // productsOps() {
    //   return (this.table.list || []).filter((i) => !i._free) || [];
    // },
    noProductHasAdvs() {
      let item = this.table.list.find((i) => i._free) || {};
      return item.account_num !== 0 || ((row.accounts || []).length > 0);
    },
  },

  created() {
    this.customer_id = this.$route.query.customerId || '';
    this._getProductList();
    this._fetchProduct('');
  },

  methods: {
    async _fetchProduct(keyword) {   
      try {
        this.table.loading = true;
        const res = await req
          .send(req.Apis.customer.common.getProductByCustomer, {
            keyword: keyword,
            customer_id: this.customer_id,
          })
          .fin(() => {
            this.table.loading = false;
          });
        let resData = [...(res.data || [])];
        this.productsOps = resData;
      
      } catch (err) {
        this.$message.error(`获取客户列表失败：${err.message || '未知错误'}`);
      }
    },
    collapseAll(flag) {
      // 获取表格的引用
      const table = this.$refs.productTable;
      // 遍历表格数据，折叠每一行
      this.$nextTick(() => {
        this.table.list.forEach(row => {
          table.toggleRowExpansion(row, flag); // 第二个参数为false表示折叠
        });
      })
      
      this.$forceUpdate();
    },
     async handleExpandChange(row, expandedRows) {
      const isExpanded = expandedRows.some(expandedRow => expandedRow.id === row.id);
      if(isExpanded && !row.accounts) {
        this.product_id = row.product_id;
        this._getAccountList(row.product_id);
      }
    },
    handlePageSizeChange(pageSize) {
      this.query.page_size = Number(pageSize);
      this._getProductList();
    },

    handleQueryPage(page) {
      this.query.page = Number(page);
      this._getProductList();
    },

    handleAccountPageSizeChange(product_id, pageSize) {
      const index = this.table.list.findIndex(i => i.product_id === product_id);
      this.table.list[index].pagination.page_size = Number(pageSize);
      this._getAccountList(product_id);
    },

    handleAccountQueryPage(product_id, page) {
      const index = this.table.list.findIndex(i => i.product_id === product_id);
      this.table.list[index].pagination.page = Number(page);
      this._getAccountList(product_id);
    },

    async _getAccountList(product_id) {
      const index = this.table.list.findIndex(i => i.product_id === product_id);        
      try {
        this.table.loading = true;
        const res = await req
          .send(req.Apis.customer.common.getProductAccount, {
            ...this.table.list[index].pagination,
            product_id: product_id,
            customer_id: this.customer_id,
          })
          .fin(() => {
            this.table.loading = false;
          });
        const list = res.data.account || [];
        this.table.list[index].account = list
      
      } catch (err) {
        this.$message.error(`获取客户列表失败：${err.message || '未知错误'}`);
      }
    },

    async _getProductList() {
      try {
        this.table.loading = true;
        const res = await req
          .send(req.Apis.customer.common.customerDetail2, {
            ...this.query,
            customer_id: this.customer_id,
          })
          .fin(() => {
            this.table.loading = false;
          });
        const list = res.data.products || [];
        list.forEach((i) => {
          i._free = i.product_id === 0;
          i._ownerName = i.owner_name || '--';
          i.account = [];
          i.pagination = {
            page: 1,
            page_size: 10,
          }
        });
        this.table.list = list;
        this.table.total = res.data.total;
        this.collapseAll(false);
      } catch (err) {
        this.$message.error(`获取客户列表失败：${err.message || '未知错误'}`);
      }
    },

    async _searchBuiness(key) {
      if (!key) return [];
      try {
        this.editBusinessDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.common.sales, {
            name: key,
          })
          .fin(() => {
            this.editBusinessDlg.searchLoading = false;
          });
        this.editBusinessDlg.options = res.data.data || [];
      } catch (err) {
        this.$message.error(`获取客保运营失败：${err.message || '未知错误'}`);
      }
    },

    async _searchSalors(key) {
      if (!key) return [];
      try {
        this.editProdSalorDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.common.sales, {
            name: key,
          })
          .fin(() => {
            this.editProdSalorDlg.searchLoading = false;
          });
        this.editProdSalorDlg.options = res.data.data || [];
      } catch (err) {
        this.$message.error(`获取客保销售失败：${err.message || '未知错误'}`);
      }
    },

    async _searchAdv(key) {
      if (!key) return [];
      try {
        this.bindAdvDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.common.searchBindableAcc, {
            adv_user_id: key,
          })
          .fin(() => {
            this.bindAdvDlg.searchLoading = false;
          });
        this.bindAdvDlg.saleOps = res.data || [];
      } catch (err) {
        this.$message.error(`获取adv列表失败：${err.message || '未知错误'}`);
      }
    },

    async _searchCustomer(key) {
      if (!key) return [];
      try {
        this.editMasterDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.common.searchCompany, {
            company: key,
          })
          .fin(() => {
            this.editMasterDlg.searchLoading = false;
          });
        this.editMasterDlg.options = res.data || [];
      } catch (err) {
        this.$message.error(`获取列表失败：${err.message || '未知错误'}`);
      }
    },

    async _processEditProdSalor() {
      try {
        this.editProdSalorDlg.loading = true;
        await req
          .send(req.Apis.customer.common.updateSales, {
            ...this.editProdSalorDlg.form,
            owner: this.editProdSalorDlg.form.owner || 0,
          })
          .fin(() => {
            this.editProdSalorDlg.loading = false;
          });
        this.editProdSalorDlg.visible = false;
        this.$message.success('修改成功');
        this._getProductList();
      } catch (err) {
        this.$message.error(`修改失败：${err.message || '未知错误'}`);
      }
    },

    async _processEditBusiness() {
      try {
        this.editBusinessDlg.loading = true;
        await req
          .send(req.Apis.customer.common.updateBusiness, {
            ...this.editBusinessDlg.form,
            opt_id: this.editBusinessDlg.form.opt_id,
          })
          .fin(() => {
            this.editBusinessDlg.loading = false;
          });
        this.editBusinessDlg.visible = false;
        this.$message.success('修改成功');
        this._getProductList();
      } catch (err) {
        this.$message.error(`修改失败：${err.message || '未知错误'}`);
      }
    },

    async _processBindAdv() {
      try {
        this.bindAdvDlg.loading = true;
        await req
          .send(req.Apis.customer.common.bindADV, this.bindAdvDlg.form)
          .fin(() => {
            this.bindAdvDlg.loading = false;
          });
        this.bindAdvDlg.visible = false;
        this.$message.success('绑定成功');
        this._getProductList();
      } catch (err) {
        this.$message.error(`绑定失败：${err.message || '未知错误'}`);
      }
    },

    async _processBindProd() {
      try {
        this.bindProdDlg.loading = true;
        const { new_product_id } = this.bindProdDlg.form;
        await req
          .send(req.Apis.customer.common.undateBindProd, {
            ...this.bindProdDlg.form,
            new_product_id: new_product_id || 0,
          })
          .fin(() => {
            this.bindProdDlg.loading = false;
          });
        this.bindProdDlg.visible = false;
        this.$message.success('绑定成功');
        this._getProductList();
      } catch (err) {
        this.$message.error(`绑定失败：${err.message || '未知错误'}`);
      }
    },

    async _processEditMaster() {
      try {
        this.editMasterDlg.loading = true;
        await req
          .send(
            req.Apis.customer.common.updateAdvCustomer,
            this.editMasterDlg.form,
          )
          .fin(() => {
            this.editMasterDlg.loading = false;
          });
        this.editMasterDlg.visible = false;
        this.$message.success('修改成功');
        this._getProductList();
      } catch (err) {
        this.$message.error(`修改失败：${err.message || '未知错误'}`);
      }
    },

    async _advExBindSalesReal(advInfo, productInfo, type) {
      try {
        await req.send(req.Apis.customer.common.updateSalesType, {
          customer_id: productInfo.customer_id,
          product_id: productInfo.product_id,
          adv_user_id: advInfo.adv_user_id,
          type: `${type}`,
        });
        this.$message.success('更新成功');
        this._getProductList();
      } catch (err) {
        this.$message.error(`更新失败：${err.message || '未知错误'}`);
      }
    },

    async _advUntyingProductReal(advInfo, productInfo) {
      try {
        await req.send(req.Apis.customer.common.unbindProd, {
          customer_id: productInfo.customer_id,
          product_id: productInfo.product_id,
          adv_user_id: advInfo.adv_user_id,
        });
        this.$message.success('更新成功');
        this._getProductList();
      } catch (err) {
        this.$message.error(`更新失败：${err.message || '未知错误'}`);
      }
    },

    getRowClass({ row, rowIndex }) {
      return !(row.account_num !== 0 || (row.accounts || []).length > 0)  ? 'hide-row-expand-icon' : '';
    },

    // 批量绑定/解绑销售关系
    batchBindSales(row, type) {
      const types = {
        1: '绑定',
        2: '解除',
      };
      const typeText = types[type];
      this.$confirm(`确定批量${typeText}销售归属关系？`, '提示', {
        confirmButtonText: `确定，${typeText}销售关系`,
        cancelButtonText: '取消',
      }).then(async () => {
        const selection = row.rowSelection || [];
        const accounts = [];
        selection.forEach((item) => {
          accounts.push({
            customer_id: item.customer_id,
            product_id: item.product_id,
            adv_user_id: item.adv_user_id,
          });
        });
        await req.send(req.Apis.customer.common.batchUpdateSalesType, {
          accounts,
          type,
        });
        this.$message.success(`批量${typeText}成功`);
        this._getProductList();
      });
    },

    handleTableSelectionChange(row, val) {
      this.noProdSelection = val;
      this.$set(row, 'rowSelection', val);
    },

    goLog() {
      this.$router.push({
        name: 'Log',
      });
    },

    async handleFilter() {
      if (!this.keyword) {
        this._getProductList();
        this.collapseAll(false);
      } else {
        try {
          this.table.loading = true;
          let keyword = this.keyword.replace(/\s/g, '');
          const res = await req
            .send(req.Apis.customer.common.getAccountPosition, {
              customer_id: this.customer_id,
              adv_user_id: keyword,
              // "customer_id": "743",
              // "adv_user_id": "1553275,1554126,1838981,1838982,"
            })
            .fin(() => {
              this.table.loading = false;
            });

          const list = res.data || [];
          this.table.list = list;
          this.table.total = res.data.total;
          this.collapseAll(true);
        } catch (err) {
          this.$message.error(`获取客户列表失败：${err.message || '未知错误'}`);
        }
      }    
      

      // this.table.list.forEach((i, index) => {
      //   let accLen = (i.account || []).length;
      //   if (accLen) {
      //     i.account.forEach((x, xi) => {
      //       if (x.adv_user_id === this.keyword) {
      //         this.$refs.productTable.toggleRowExpansion(i, true);
      //         this.$nextTick(() => {
      //           this.getCurrentAdvCellAndNavigate();
      //         });
      //       }
      //     });
      //   }
      // });
    },

    modifySaler(item) {
      this.editProdSalorDlg.form.customer_id = item.customer_id;
      this.editProdSalorDlg.form.product_id = item.product_id;
      this.editProdSalorDlg.form.owner =
        Number(item.owner) === 0 ? '' : item.owner;
      // this.editProdSalorDlg.accountNum =
      //   (item.account && item.account.length) || 0;

      this.editProdSalorDlg.accountNum = item.account_num ?  Number(item.account_num) :
        (item.accounts || []).length;

      this.editProdSalorDlg.form.owner &&
        (this.editProdSalorDlg.options = [
          { id: item.owner, name: item.owner_name },
        ]);
      this.editProdSalorDlg.visible = true;
    },

    modifyBusiness(item) {
      this.editBusinessDlg.form.customer_id = item.customer_id;
      this.editBusinessDlg.form.product_id = item.product_id;
      this.editBusinessDlg.form.opt_id =
        Number(item.opt_id) === 0 ? '' : item.opt_id;
      // this.editBusinessDlg.accountNum = 
      //   (item.account && item.account.length) || 0;
      this.editBusinessDlg.accountNum = item.account_num ?  Number(item.account_num) :
        (item.accounts || []).length;
        
      this.editBusinessDlg.form.opt_id &&
        (this.editBusinessDlg.options = [
          { id: item.opt_id, name: item.opt_name },
        ]);
      this.editBusinessDlg.visible = true;
    },

    bindAdv(item) {
      this.bindAdvDlg.saleOps = [];
      this.bindAdvDlg.form.customer_id = item.customer_id || '';
      this.bindAdvDlg.form.product_id = item.product_id || '';
      this.bindAdvDlg.form.adv_user_id = '';
      this.bindAdvDlg.visible = true;
    },

    modifyMaster(item) {
      if (this.noProdSelection.length) {
        this.editMasterDlg.form.adv_user_ids = this.noProdSelection
          .map((i) => i.adv_user_id)
          .join(',');
        this.editMasterDlg.form.old_customer_id = Number(item.customer_id);
        this.editMasterDlg.form.new_customer_id = '';
        this.editMasterDlg.visible = true;
      } else {
        this.$message('请先选择adv');
      }
    },

    submitEditProdSalor() {
      this.$refs.prodSalorForm.validate((valid) => {
        if (valid) {
          this._processEditProdSalor();
        } else {
          return false;
        }
      });
    },

    submitEditBusiness() {
      this.$refs.businessForm.validate((valid) => {
        if (valid) {
          this._processEditBusiness();
        } else {
          return false;
        }
      });
    },

    submitBindAdvDlgForm() {
      this.$refs.bindAdvForm.validate((valid) => {
        if (valid) {
          this._processBindAdv();
        } else {
          return false;
        }
      });
    },

    submitBindProdDlgForm() {
      this.$refs.bindProdForm.validate((valid) => {
        if (valid) {
          this._processBindProd();
        } else {
          return false;
        }
      });
    },

    // 解绑:2 / 绑定:1 销售归属关系
    advExBindSales(advInfo, productInfo, type = 1) {
      const _text = type === 1 ? '绑定销售归属关系' : '销售归属关系解除';
      const _btn = type === 1 ? '确定，绑定归属' : '确定，解除销售关系';
      this.$confirm(
        `确定将ADV编号【${advInfo.adv_user_id}】${_text}？`,
        '提示',
        {
          confirmButtonText: _btn,
          cancelButtonText: '取消',
        },
      ).then(() => {
        this._advExBindSalesReal(advInfo, productInfo, type);
      });
    },

    // 解绑产品关系
    advUntyingProduct(advInfo, productInfo) {
      this.$confirm(
        `确定解除ADV编号【${advInfo.adv_user_id}】和产品【${productInfo.product_name}】的关系？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        },
      ).then(() => {
        this._advUntyingProductReal(advInfo, productInfo);
      });
    },

    // 批量关联产品
    advBatchBindProduct(row) {
      const selection = row.rowSelection || [];
      const users = [];
      selection.forEach((item) => {
        users.push(item.adv_user_id);
      });
      const productId = row.product_id;
      this.bindProdDlg.form.old_product_id = productId;
      this.bindProdDlg.form.new_product_id = productId === 0 ? '' : productId;
      this.bindProdDlg.form.adv_user_ids = users.join(',');
      this.bindProdDlg.form.customer_id = row.customer_id;
      this.bindProdDlg.visible = true;
    },
    // 关联产品
    advBindProduct(advInfo, productInfo) {
      const productId = productInfo.product_id;
      this.bindProdDlg.form.old_product_id = productId;
      this.bindProdDlg.form.new_product_id = productId === 0 ? '' : productId;
      this.bindProdDlg.form.adv_user_ids = advInfo.adv_user_id;
      this.bindProdDlg.form.customer_id = productInfo.customer_id;
      this.bindProdDlg.visible = true;
    },

    getCurrentAdvCellAndNavigate() {
      // 运营代码迁移
      const _cls = 'expand-adv-user-id';
      const wrapper = document.querySelector('.content-container');
      let wrapperHeight = wrapper.getBoundingClientRect()['height'];

      let cellDomList = document.getElementsByClassName(_cls);
      let cellArr = Array.prototype.slice.call(cellDomList) || [];
      cellArr.filter((i) => {
        let targetText = i.innerText || i.innerHTML || '';
        if (targetText === this.keyword) {
          let _scroll =
            i.getBoundingClientRect()['top'] - wrapperHeight / 2 + 280;
          wrapper.scrollTop = _scroll;
          const _parent = i.parentNode.parentNode.parentNode;
          _parent.setAttribute('class', 'el-table__row ani');
          if (this._searchTime) {
            clearTimeout(this.searchTime);
            this._searchTime = null;
          }
          this._searchTime = setTimeout(() => {
            _parent.setAttribute('class', 'el-table__row');
          }, 5000);
        }
        return i;
      });
    },
  },
};
</script>
<style lang="less">
.customer-product-list-page {
  .hide-row-expand-icon {
    .el-table__expand-icon {
      visibility: hidden;
    }

    & + tr {
      .el-table__expanded-cell {
        padding: 0;
        border: 0;
      }
    }
  }

  .el-table__row {
    &.ani {
      animation: active-twinkling 0.45s linear 0s infinite alternate forwards;
    }
  }

  .el-table__expanded-cell {
    padding: 16px 0 16px 16px;
  }
}
</style>
